// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadablePaint } from '@confluence/loadable';

export {
	useNewContentHistoryState,
	useNewContentHistoryActions,
	useNewContentHistory,
} from './useNewContentHistoryState';
export { useNewContentHistoryEditorTransition } from './useNewContentHistoryEditorTransition';

export const NewContentHistory = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-NewContentHistory" */ './NewContentHistory'))
			.NewContentHistory,
});
